document.addEventListener("DOMContentLoaded", function(){
  if($(".icon-videoplays").length > 0 && $(`video`).length > 0) {
    var curVideo = window.innerWidth >= 591 ? $(`video:not(.mb-video)`)[0] : $(`video:not(.pc-video)`)[0];
    // 不确定是否与主题global.js中的pauseAllMedia冲突；需延迟播放视频
    let videoTimer = setTimeout(() => {
      curVideo.play().then(() =>{
        clearTimeout(videoTimer);
      }).catch(error => {
        console.error('Error during play:', error);
      });
    }, 1000);
    $(document).on(`click`, `.icon-videoplays`, function (e) {
      var _that = $(this);
      var temp_video = window.innerWidth >= 591 ? $(`video:not(.mb-video)`)[0] : $(`video:not(.pc-video)`)[0];
      if (temp_video.paused) {
        temp_video.play();
        _that.attr('aria-label', 'Pause video');
        _that.html(
          `<svg role="img" aria-label="Pause video" aria-labelledby="pause-video-title" class="icon " aria-hidden="true" t="1713405533408" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10166" width="32" height="32"><title id="pause-video-title">Pause Video</title><path d="M413.866667 320c-17.066667 0-32 14.933333-32 32v320c0 17.066667 14.933333 32 32 32s32-14.933333 32-32v-320c0-17.066667-14.933333-32-32-32zM605.866667 320c-17.066667 0-32 14.933333-32 32v320c0 17.066667 14.933333 32 32 32s32-14.933333 32-32v-320c0-17.066667-14.933333-32-32-32z" fill="currentColor" p-id="10167"></path><path d="M509.866667 32C245.333333 32 32 247.466667 32 512s213.333333 480 477.866667 480S987.733333 776.533333 987.733333 512 774.4 32 509.866667 32z m0 896C281.6 928 96 742.4 96 512S281.6 96 509.866667 96 923.733333 281.6 923.733333 512s-185.6 416-413.866666 416z" fill="currentColor" p-id="10168"></path></svg><span class="sr-only">Pause video</span>`
        );
      } else {
        temp_video.pause();
        _that.attr('aria-label', 'Play video');
        _that.html(
          '<svg role="img" aria-label="Play video" aria-labelledby="play-video-title" class="icon" aria-hidden="true" data-prefix="fal" data-icon="play-circle" viewBox="0 0 512 512" class="svg-inline--fa fa-play-circle fa-w-16 fa-3x"><title id="play-video-title">Play Video</title><path fill="currentColor" d="M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zM40 256c0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216zm331.7-18l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM192 335.8V176.9c0-4.7 5.1-7.6 9.1-5.1l134.5 81.7c3.9 2.4 3.8 8.1-.1 10.3L201 341c-4 2.3-9-.6-9-5.2z" class=""></path></svg><span class="sr-only">Play video</span>'
        );
      }
    });
    $(document).on(`keydown`, `.icon-videoplays`, function (e) {
      if (e.key == "Enter" || e.key == " ") {
        e.preventDefault();
        $(this).click();
      }
    });
  }
});